import src from "IMAGE";
export default { src, width: 540, height: 540, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAANklEQVR42r3OuQ0AIAxDUQvYAxDiaNh/vfwiRSZIpBe5cGEp5QoWPobnjYkqfw8HHTcUWsJAA+USAcDyCwQyAAAAAElFTkSuQmCC"};
